import { createContext, type PropsWithChildren, useCallback, useRef, useState } from 'react'
import type { DownloadingContextValue, DownloadingItem } from '../types/downloading.type'

export const DownloadingContextProvider = createContext<DownloadingContextValue | undefined>(undefined)

export const DownloadingProvider = ({ children }: PropsWithChildren) => {
  const [isLoading, setIsLoading] = useState(false)
  const [currentItems, setCurrentItems] = useState<DownloadingItem[]>([])
  const [error, setError] = useState<unknown>(null)
  const pendingCountRef = useRef(0)

  const startDownloading = useCallback((items: DownloadingItem[]) => {
    pendingCountRef.current += 1
    setIsLoading(true)
    setCurrentItems(items)
  }, [])

  const finishDownloading = useCallback(() => {
    pendingCountRef.current = Math.max(0, pendingCountRef.current - 1)
    if (pendingCountRef.current === 0) {
      setIsLoading(false)
      setCurrentItems([])
    }
  }, [])

  const resetError = useCallback(() => {
    setError(null)
  }, [])

  return (
    <DownloadingContextProvider.Provider
      value={{
        isLoading,
        currentItems,
        error,
        startDownloading,
        finishDownloading,
        setError,
        resetError,
      }}
    >
      {children}
    </DownloadingContextProvider.Provider>
  )
}
